import {Headers, Http} from "@angular/http";
import {Injectable} from "@angular/core";
import {Local} from "../config-support/config";
import {LocalConfigurationService} from "@fedelta-pos/data-client";

export class TableLookupResponse {
    public id?: string;
    public storeGroup?: string;
    public exclusiveStoreGroup?: string;
    public stores?: number[];
    public exclusiveStores?: number[];
    public tableNumber?: string;
    public tableOnlyMode?: boolean;
    public pickupOnlyMode?: boolean;
    public redirectURL: string;
}

@Injectable()
export class ChewzieTableLookupService {
    private readonly DEFAULT_TABLE_LOOKUP_URL: string = "https://u.chewzie.me";

    private tableLookupUrl: string;
    private loginToken: string;

    constructor(private http: Http,
                private localConfigurationService: LocalConfigurationService) {
        console.log("--- ChewzieTableLookupService");
    }

    public async getTableLookupUrl(): Promise<string> {
        if (!this.tableLookupUrl) {
            this.tableLookupUrl = await this.localConfigurationService.getString(Local.TABLE_LOOKUP_URL);
            if (!this.tableLookupUrl) {
                this.tableLookupUrl = this.DEFAULT_TABLE_LOOKUP_URL;
            }
        }
        return this.tableLookupUrl;
    }

    public async getLoginToken(): Promise<string> {
        if (!this.loginToken) {
            this.loginToken = await this.localConfigurationService.getString(Local.LOGIN_TOKEN);
        }
        return this.loginToken;
    }

    async lookupTable(scannedUrl: string): Promise<TableLookupResponse> {
        const url = new URL(await this.getTableLookupUrl() + "/lookup-table");
        url.searchParams.append("scannedUrl", btoa(scannedUrl));
        return Object.assign(new TableLookupResponse(), (await this.http.get(url.href, {headers: new Headers({token: await this.getLoginToken()})}).toPromise()).json());
    }
}



// WEBPACK FOOTER //
// ./src/app/ordering-context/chewzie-table-lookup.service.ts